
export default class OrderHelper {
    static getOrdersOfSession = (app, sessionId) => {
        return app.state.adminOrders.filter(order => order.table_session_id == sessionId )
    }
    static getTotalPriceAsString = (app, sessionId) => {
        // let orders = OrderHelper.getOrdersOfSession(app, sessionId)
        const totalPrice = OrderHelper.getTotalPrice(app, sessionId)
        return totalPrice == 0 ? app.state.currencyName+" 0.00" : app.state.currencyName+" " + totalPrice.toFixed(2)
    }
    static getTotalPrice = (app, sessionId) => {
        let orders = OrderHelper.getOrdersOfSession(app, sessionId)
        return (!orders || orders.length == 0 ) ? 0.0 : (orders.map((order) => (order.order_status == "void" ? "0" : order.order_total))
                .reduce((order1, order2) => {return (parseFloat(order1) || 0) + (parseFloat(order2) || 0)}, 0) * 1)
    }
}